export const topNavItems = [
  { content: "عن بوكّلاود", href: "/about-us" },
  { content: "شروط الاستخدام", href: "/terms-and-conditions" },
  { content: "اسئله و اجوبة", href: "/dummy" },
];
